<template lang="html">
    <div class="table-responsive">
        <table class="table center-aligned-table">
            <thead>
                <tr>
                    <th class="border-bottom-0">No.</th>
                    <th class="border-bottom-0">Pickup Number</th>
                    <th class="border-bottom-0">Customer name</th>
                    <th class="border-bottom-0">Phone number</th>
                    <th class="border-bottom-0">Ordered time</th>
                    <th class="border-bottom-0">Pickup time</th>
                    <th class="border-bottom-0">Total</th>
                    <th class="border-bottom-0">Status</th>
                    <th class="border-bottom-0">Actions</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="(o, index) in currentOrders">
                    <tr>
                        <td> {{ index + 1 }} </td>
                        <td> {{ o.pickupNumber }} </td>
                        <td> {{ o.customerName }} </td>
                        <td> {{ o.phoneNumber }} </td>
                        <td> {{ getOrderedTime(o.createdDate) }} </td>
                        <td> {{ o.pickupTime }} </td>
                        <td> {{ getOrderTotal(o) }} </td>
                        <td> {{ o.status }} </td>
                        <td>
                            <div class="btn-group">
                                <button type="button" 
                                        class="btn btn-sm btn-outline-secondary"
                                        v-b-toggle="index.toString()">
                                    <i class="mdi mdi-information text-primary"></i>View
                                </button>
                            </div>       
                        </td>
                    </tr>
                    <tr>
                        <td colspan="8">
                            <b-collapse :id="index.toString()" 
                                        class="mt-2">
                                <b-card>
                                    <b-table striped hover :items="o.orderDetails"
                                                            :fields="fields">
                                    </b-table>
                                    <br>
                                    <div>
                                        Comment: {{ o.comment }}
                                    </div>
                                </b-card> 
                            </b-collapse> 
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        <!-- <b-modal id="modalOrderDetailView" 
                 title="Order details"
                 hide-footer
                 centered>
            <b-card>
                <b-table striped hover :items="currentDetailOrder"
                                       :fields="fields">
                </b-table>
                <br>
                <div>
                    Comment: {{ o.comment }}
                </div>
            </b-card>                                       
        </b-modal> -->
    </div>     
</template>

<script lang="js">
import { mapState, mapGetters } from'vuex'
import RestaurantChangedBase from '../Bases/RestaurantChangedBase'
export default{
    name: 'currentorders',
    extends: RestaurantChangedBase,
    computed : {
        ...mapState({
            currentOrders : state => state.ordermessages.currentOrders,
            visibleRows : state => state.ordermessages.visibleRows,
        })
    },
    data () {
        return {
            fields : ['itemName', 'quantity', 'itemPrice', 'categoryName'],
            currentDetailOrder : null
        }
    },
    methods: {
        getStatus(status) {
            if (status === 0) {
                return 'Unfinished'
            }
            if (status === 1) {
                return 'Overtime'
            }
            if (status === 2) {
                return 'Ready'
            }
        },
        getOrderedTime(orderedTime) {
            return this.$moment(orderedTime).hour() + ':' + this.$moment(orderedTime).minute();
        },
        getOrderTotal(order) {
            let total = 0;
            order.orderDetails.forEach(o => {
                total += o.itemPrice * o.quantity;
            })
            return total + ' kr';
        },

        getCurrentDetailOrder(index) {

        }

    },
    async created() {
        this.$store.dispatch('ordermessages/getCurrentOrdersAction');
        this.setAction('ordermessages/getCurrentOrdersAction');
    }
}
</script>

<style lang="scss">
  
</style>